import {
  Done as DoneIcon,
  Error as ErrorIcon,
  ErrorOutline as ErrorOutlineIcon,
  AutoMode as AutoModeIcon,
  Inventory2 as Inventory2Icon,
} from '@mui/icons-material';
import { Popper, Paper, Typography, Box, Tooltip, ClickAwayListener } from '@mui/material';
import { useState, useRef } from 'react';

export const FileStatusIndicator = ({ fileName, status, searchTerm }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);   

  const statusConfig = {
    ready: {
      icon: <DoneIcon color="success" fontSize="small" />,
      textIcon: <DoneIcon color="white" fontSize="small" />,
      message: "File is ready to use.",
      color: 'success.main',
      bgColor: 'success.dark',
      textColor: 'common.white',
    },
    error: {
      icon: <ErrorIcon color="error" fontSize="small" />,
      textIcon: <ErrorOutlineIcon color="white" fontSize="small" />,
      message: "There was an issue processing the file.",
      color: 'error.main',
      bgColor: 'error.dark',
      textColor: 'common.white',
    },
    processing: {
      icon: <AutoModeIcon color="warning" fontSize="small" />,
      textIcon: <AutoModeIcon color="white" fontSize="small" />,
      message: "File is being processed.",
      color: 'warning.main',
      bgColor: 'warning.dark',
      textColor: 'common.white',
    },
    archived: {
      icon: <Inventory2Icon fontSize="small" />,
      textIcon: <Inventory2Icon color="white" fontSize="small" />,
      message: "Plan is archived.",
      color: 'grey',
      bgColor: 'grey',
      textColor: 'common.white',
    },
  };

  const config = statusConfig[status];

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {/* Icon with Popper */}
      <Box
        ref={anchorRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{ display: 'flex' }}
      >
        {config.icon}
      </Box>

        <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="left"
        modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
        sx={{ zIndex: 1300, width: "260px" }}
        >
        <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Paper
            elevation={3}
            sx={{
                p: 1.5,
                bgcolor: config.bgColor,
                color: config.textColor,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
            }}
            >
            <Typography 
                variant="body2"
                sx={{
                py: 1, paddingLeft: 2, paddingRight: 4,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontFamily: 'Manrope,sans-serif',
                fontSize: '0.875rem',
                lineHeight: 1.5
                }}
            >
                {config.textIcon}
                {typeof config.message === 'string' ? config.message : config.message.props.children[1]}
            </Typography>
            </Paper>
        </ClickAwayListener>
        </Popper>

      {/* Filename with Tooltip */}
      <Tooltip title={fileName} arrow>
        <Typography
          sx={[
            {
              display: 'inline-block',
              fontSize: '0.875rem',
            },
            !searchTerm && {
              maxWidth: 'auto'
            },
          ]}
        >
          {fileName}
        </Typography>
      </Tooltip>
    </Box>
  );
};